import validate from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@26.1.2_@vue+c_16621045e53f933fd4b5094b9abc67e1/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/auth.global.js";
import manifest_45route_45rule from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@26.1.2_@vue+c_16621045e53f933fd4b5094b9abc67e1/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "company-guard": () => import("/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/companyGuard.js")
}